// extracted by mini-css-extract-plugin
export var dividerLine = "_90-3";
export var itemImage = "_90-9";
export var lightDivider = "_90-4";
export var modalContent = "_90-5";
export var modalContentCompact = "_90-6";
export var productCard = "_90-a";
export var productImage = "_90-b";
export var productImageCompact = "_90-7";
export var productImagePlaceholder = "_90-c";
export var productImagePlaceholderCompact = "_90-8";
export var progressBarBackground = "_90-1";
export var progressBarContainer = "_90-0";
export var progressBarFill = "_90-2";